export const powerDeliveryHero = require('images/expertise/power-delivery/PowerDeliveryHero.webp');
export const powerInfrastructureSolutions = require('images/expertise/power-delivery/PowerInfrastructureSolutions.webp');
